import { Flota } from '..';

export interface PlanificadoresPagingRes {
  count: number;
  next: string;
  previous: null;
  numero_paginas: number;
  data: Planificador[];
}

export interface Planificador {
  id_planificador?: string;

  codigo: string; // unique

  numero_referencia?: string;
  estado: boolean;

  time_map: TimeMapPlanificador[];

  fecha_inicio: string; // monday
  fecha_fin: string | null; // sunday
  fecha_maxima: string;
  fecha_minima: string;
  fecha_creacion: string;
  fecha_modificacion: string;

  ///* fk
  flota?: string; // codigo
  flota_data?: Flota;
}

export interface TimeMapPlanificador {
  fecha: string;
  horas: HoraTimeMapPlanificador[];
}

export interface HoraTimeMapPlanificador {
  hora: number;
  estado: boolean;
  id_user?: number;
  id_preventa?: string;
  fecha_hora_limite?: string;
  motivo?: string;
  historial?: {
    user: string;
    estado: boolean;
    fecha_hora: string;
  }[] | null
}

export interface CalendarComponentState {
  bool: boolean;
  selectedSlotDate: {
    start: Date;
    end: Date;
  } | null;
}

export interface PlanificadorEvent extends Omit<HoraTimeMapPlanificador, 'historial'> {
  title: string; // Título del evento
  start: string; // Fecha de inicio
  end: string;   // Fecha de finalización
  backgroundColor: string;
  textColor: string;
  username?: string | null;
};

interface HoraCalendar extends HoraTimeMapPlanificador {
  start: Date;
  end: Date;
}

export interface HorarioCalendar extends TimeMapPlanificador {
  horas: HoraCalendar[];
}



///* form

export type fechasArrObj = { fecha_inicio: string; fecha_fin: string }
export interface CreatePlanificadorForm {
  flota: string;
  fecha_inicio?: string; //  fecha inicio

  // helpers
  tipoPlanificador?: string;
  fecha_fin?: string;

  minDate?: string;
  fechasArrObj?: fechasArrObj[];
  /* 
  {
        "fecha_inicio": "2024-07-15",
        "fecha_fin": "2024-07-21"
    }
  */
}
export interface PermanentBlockTimeForm {
  user_id: number;
  motivo?: string;

  // one by one ----
  hora?: number; // only one hour
  fecha?: string; // 'YYYY-MM-DD' - only hour

  // multi slots/events selected ----
  horas?: number[]; // array of hours
  // fecha?: string; // del dia del array de horas

  // range ----
  fecha_inicio?: string; // 'YYYY-MM-DD' bloqueo x range
  fecha_fin?: string; // 'YYYY-MM-DD' bloqueo x range
}
export interface UnblockTimeForm {
  user_id: number;

  // one by one ----
  hora?: number;
  fecha?: string; // 'YYYY-MM-DD'

  // multi slots/events selected ----
  horas?: number[]; // array of hours
  // fecha?: string; // del dia del array de horas

  // range ----
  fecha_inicio?: string; // 'YYYY-MM-DD' - desbloqueo x range
  fecha_fin?: string; // 'YYYY-MM-DD' - desbloqueo x range
}

export enum TipoPlanificador {
  AUTOMATICO = 'AUTOMATICO',
  MANUAL = 'MANUAL',
}
